<form [formGroup]="form">
    <div formArrayName="scopes">
        <section #scopesid>
            @for (scope of scopeFormArray.controls; track scope; let i = $index) {
                <label>
                    <input id="i" type="checkbox" [formControlName]="i">
                    <span>{{ scopes[i].name }}</span>
                </label>
            }
        </section>
    </div>
</form>

